// extracted by mini-css-extract-plugin
module.exports = {"seprator":"_1VYTl","active":"_36Vwl","disabled":"EdGR9"};